"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IS_SANDBOX = exports.BOOKING_SESSION_ID = exports.DEEPLINK_ID = exports.SESSION_ID = exports.ACCOUNT_ID = exports.EMAIL = void 0;
const EMAIL = "email";
exports.EMAIL = EMAIL;
const ACCOUNT_ID = "accountId";
exports.ACCOUNT_ID = ACCOUNT_ID;
const SESSION_ID = "sessionId";
exports.SESSION_ID = SESSION_ID;
const DEEPLINK_ID = "deeplinkId";
exports.DEEPLINK_ID = DEEPLINK_ID;
const BOOKING_SESSION_ID = "bookingSessionId";
exports.BOOKING_SESSION_ID = BOOKING_SESSION_ID;
const IS_SANDBOX = "isSandbox";

// TODO specific once everyone uses this
exports.IS_SANDBOX = IS_SANDBOX;